import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { Layer } from 'bernie-view';
import { LocalizedText } from 'bernie-l10n';
import { QueryRoute, RouteStore } from 'bernie-core';

import { SearchResultsStore } from 'stores/search-results-store';

import { SearchFormFields } from 'models';

import { FiltersDialog } from './filters-dialog';

export interface FiltersToggleProps {
  className?: string;
  routeStore?: RouteStore;
  searchResults?: SearchResultsStore;
  showActions?: boolean;
  isActive: boolean;
  buttonComponent: React.ReactNode;
  isFullWidth: boolean;
  label: string;
  a11yMessage: string;
  rfrr: string;
  stid: string;
  filters: SearchFormFields;
  dialogParam: string;
  dialogTitle: string;
}

@inject('layerManager', 'routeStore', 'searchResults')
@observer
export class FiltersToggle extends React.Component<FiltersToggleProps> {
  private filtersBtn: React.RefObject<HTMLElement>;

  constructor(props: FiltersToggleProps) {
    super(props);

    this.filtersBtn = React.createRef();
    this.onDismiss = this.onDismiss.bind(this);
  }

  public static defaultProps = {
    isActive: false
  };

  public render() {
    // tslint:disable-next-line:max-line-length
    const {
      isActive,
      searchResults,
      routeStore,
      buttonComponent,
      isFullWidth,
      label,
      a11yMessage,
      rfrr,
      stid,
      filters,
      dialogParam,
      dialogTitle
    } = this.props;
    const { isLoading, isError, sortAndFilter } = searchResults;
    const appliedFilterCount = sortAndFilter && sortAndFilter.options && sortAndFilter.options.appliedFilterCount;

    const filtersApplied = appliedFilterCount > 0;
    const openFiltersQuery = routeStore.mergeQueryString(routeStore.search, { pwaDialog: dialogParam });
    const ButtonTracked = ClickTracker(buttonComponent);
    const extraProps =
      isActive && sortAndFilter && Object.keys(sortAndFilter).length > 0
        ? {
            domRef: this.filtersBtn,
            tag: Link,
            to: {
              pathname: routeStore.pathname,
              search: openFiltersQuery
            }
          }
        : {};

    const buttonText = (
      <>
        {filtersApplied && (
          <span className="is-visually-hidden">
            <LocalizedText message={a11yMessage} data={[appliedFilterCount]} />
          </span>
        )}
        <LocalizedText message={label} />
      </>
    );

    return (
      <React.Fragment>
        <ButtonTracked
          data-stid={stid}
          disabled={!isActive || isLoading || isError || null}
          linkName="Launch filters takeover"
          rfrr={rfrr}
          icon={filtersApplied ? null : 'tune'}
          badgeText={filtersApplied ? appliedFilterCount : null}
          badgeType="notification-1"
          text={buttonText}
          isFullWidth={isFullWidth}
          {...extraProps}
        />
        <QueryRoute query={{ pwaDialog: dialogParam }}>
          <Layer id="tools-filterdrawer" onDismiss={this.onDismiss}>
            <FiltersDialog
              searchCriteria={searchResults.searchCriteria}
              onDismiss={this.onDismiss}
              {...{ searchResults, filters, dialogTitle }}
            />
          </Layer>
        </QueryRoute>
      </React.Fragment>
    );
  }

  private onDismiss(): void {
    const { routeStore } = this.props;

    if (routeStore && typeof routeStore.goBack === 'function') {
      routeStore.goBack();
    }

    if (this.filtersBtn.current && typeof this.filtersBtn.current.focus === 'function') {
      this.filtersBtn.current.focus();
    }
  }
}
